<template>
  <!--
    Un bouton qui ouvre son contenu dans une fenêtre, au lieu de le poser au-dessus d'une liste : la liste reste en haut.
    Le contenu est monté tout de suite (eager), pour que le compteur du bouton soit juste avant la première ouverture.
  -->
  <span class="dialog-button">
    <v-badge :value="!!count" :content="count" :color="alert ? 'error' : 'grey darken-1'" overlap offset-x="12" offset-y="12">
      <v-btn small outlined :color="alert ? 'error' : 'primary'" @click="open = true">
        <v-icon small left>{{ icon }}</v-icon>{{ label }}
      </v-btn>
    </v-badge>
    <v-dialog v-model="open" :max-width="maxWidth" scrollable eager>
      <v-card>
        <v-card-title class="py-3">
          <span class="text-h6">{{ title || label }}</span>
          <v-spacer />
          <v-btn icon :aria-label="$t('close')" @click="open = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <slot :close="close" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  name: 'DialogButton',

  props: {
    label: { type: String, required: true },
    title: { type: String, default: null },
    icon: { type: String, default: 'mdi-open-in-app' },
    /** Ce qui attend (commandes en cours, invitations…) : en pastille ; 0, pas de pastille. */
    count: { type: Number, default: 0 },
    /** Quelque chose attend une décision : le bouton et sa pastille passent en rouge. */
    alert: { type: Boolean, default: false },
    maxWidth: { type: [Number, String], default: 1100 },
  },

  data() {
    return { open: false }
  },

  methods: {
    close() {
      this.open = false
    },
  },
}
</script>
